import { useMemo } from 'react';

import { useAllSources } from './hooks/useAllSources';

/**
 * Hook to build a domain -> display name map from the shared source data pipeline.
 * Uses useAllSources() to avoid duplicating the fetch/merge/deduplicate logic.
 */
export const useDomainDisplayNames = () => {
  const { allSources, isLoading } = useAllSources();

  const domainDisplayNames = useMemo(() => {
    const map = new Map<string, string>();
    for (const source of allSources) {
      map.set(source.domain, source.label);
    }
    return map;
  }, [allSources]);

  /**
   * Get display label for a domain
   */
  const getDomainLabel = (domain: string): string => {
    return domainDisplayNames.get(domain) ?? domain;
  };

  return {
    domainDisplayNames,
    getDomainLabel,
    isLoading,
  };
};
